import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-empty',
  template: '',
  standalone: true
})
export class AdminEmptyComponent {}
